import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import ExpenseCategoryServiceModel, {
  CreateExpenseCategoryServiceModel,
  UpdateExpenseCategoryServiceModel,
} from "../../../viewModels/Dictionaries/ExpenseCategoryServiceModel";
import SortObject from "../../../types/SortObject";

const initialState: {
  loading: boolean;
  loadingData: boolean;
  expenseCategoryServices: Array<ExpenseCategoryServiceModel>;
  total: number;
  pageSize: number;
  page: number;
  sort?: SortObject;
  searchFilterValue: string;
  expenseCategoryServiceIdToEdit?: number;
  isEditDrawerLoading: boolean;
  isEditDrawerOpen: boolean;
} = {
  loading: true,
  loadingData: true,

  expenseCategoryServices: undefined!,
  total: undefined!,
  pageSize: 10,
  page: 1,

  searchFilterValue: "",

  isEditDrawerLoading: false,
  isEditDrawerOpen: false,
};

const expenseCategoryServicesSlice = createSlice({
  name: "expenseCategoryServices",
  initialState,
  reducers: {
    loadexpenseCategoryServices(state) {
      state.loadingData = true;
      state.page = 1;
    },
    loadexpenseCategoryServicesSuccess(
      state,
      action: PayloadAction<{ expenseCategoryServices: Array<ExpenseCategoryServiceModel>; total: number }>,
    ) {
      const { expenseCategoryServices, total } = action.payload;
      state.loading = false;
      state.loadingData = false;
      state.expenseCategoryServices = expenseCategoryServices;
      state.total = total;
    },
    loadexpenseCategoryServicesError(state) {
      state.loading = false;
      state.loadingData = false;
    },
    changeTable(state, action: PayloadAction<{ page: number; pageSize: number; sort: SortObject }>) {
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.sort = action.payload.sort;
      state.loadingData = true;
    },
    changeSearchFilterValue(state, action: PayloadAction<string>) {
      state.searchFilterValue = action.payload;
    },
    search(state) {
      state.loadingData = true;
      state.page = 1;
    },
    openEditDrawer(state, action: PayloadAction<number | undefined>) {
      state.expenseCategoryServiceIdToEdit = action.payload!;
      state.isEditDrawerOpen = true;
    },
    closeEditDrawer(state) {
      if (!state.isEditDrawerLoading) {
        state.expenseCategoryServiceIdToEdit = undefined!;
        state.isEditDrawerOpen = false;
      }
    },

    createExpenseCategoryService(state, _action: PayloadAction<CreateExpenseCategoryServiceModel>) {
      state.isEditDrawerLoading = true;
    },
    createExpenseCategoryServiceSuccess(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },
    createExpenseCategoryServiceError(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },

    updateExpenseCategoryService(state, _action: PayloadAction<UpdateExpenseCategoryServiceModel>) {
      state.isEditDrawerLoading = true;
    },
    updateExpenseCategoryServiceSuccess(state, action: PayloadAction<UpdateExpenseCategoryServiceModel>) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
      const index = state.expenseCategoryServices.findIndex((x) => x.id === action.payload.id);
      state.expenseCategoryServices[index] = action.payload;
    },
    updateExpenseCategoryServiceError(state) {
      state.isEditDrawerLoading = false;
      state.isEditDrawerOpen = false;
    },

    deleteExpenseCategoryService(state, _action: PayloadAction<number>) {
      state.loadingData = true;
    },
  },
});

export default expenseCategoryServicesSlice;
